/*
 * File: AsanaOverviewCard..tsx
 * Project: a-a
 * File Created: Tuesday, 22nd April 2025 1:49:02 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Tuesday, 29th April 2025 10:46:22 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import React from 'react';
import CustomCard from '../../../shared/CustomCard/CustomCard';
import zeplinColor from '../../../../theme/Color';
import { Box, Typography } from '@mui/material';

const AsanaOverviewCard = ({
  data,
  icon,
  title,
  backgroundColor,
}: {
  data: number;
  title: string;
  icon: string;
  backgroundColor: string;
}) => {
  return (
    <CustomCard
      styles={{
        borderRadius: '16px',
        padding: '24px',
        backgroundColor: backgroundColor,
        // width: '195.5px',
        height: '195px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        //   alignItems: 'center',
        flex: 1,
        gap: '16px',
      }}
    >
      {' '}
      <img src={icon} width='48px' height='48px' />
      <Box sx={{ display: 'flex', gap: '16px', flexDirection: 'column' }}>
        <Typography variant='display4'>{data}</Typography>
        <Typography variant='body3'>{title}</Typography>
      </Box>
    </CustomCard>
  );
};

export default AsanaOverviewCard;
